import React, { FunctionComponent } from 'react';

import { RouterLink } from 'app/src/components/RouterLink';
import { useTrelloBoardQuery } from './TrelloBoardQuery.generated';

import { KnownService, KnownServiceComponentProps } from './KnownService';

// eslint-disable-next-line @trello/less-matches-component
import styles from './KnownService.less';

interface OwnProps extends KnownServiceComponentProps {
  fullUrl: string;
  pathname: string;
  shortLink: string;
}

interface TrelloBoardComponentUnconnectedProps extends OwnProps {
  board?: {
    url: string;
    name: string;
  };
}

export const TrelloBoardComponentUnconnected = (
  props: TrelloBoardComponentUnconnectedProps,
) => {
  const { board, fullUrl, pathname, shortLink, ...rest } = props;
  const anchorProps = rest;

  const fallbackUrl = shortLink ? `/b/${shortLink}` : pathname;
  const url = board?.url ? board.url : fallbackUrl;
  const name = board?.name ? board.name : fullUrl;

  return (
    <RouterLink
      {...anchorProps}
      href={url}
      className={styles.knownServiceLink}
      target=""
      rel=""
    >
      <img
        className={styles.knownServiceIcon}
        alt="Trello Icon"
        src={require('resources/images/services/trello.png')}
      />
      {name}
    </RouterLink>
  );
};

const TrelloBoardComponent: FunctionComponent<OwnProps> = ({
  shortLink,
  fullUrl,
  pathname,
}) => {
  const { data, loading } = useTrelloBoardQuery({
    variables: {
      shortLink: shortLink,
    },
    skip: !shortLink,
  });

  if (loading || !data?.board) {
    return null;
  }

  const board = data.board;

  return (
    <TrelloBoardComponentUnconnected
      fullUrl={fullUrl}
      shortLink={shortLink}
      pathname={pathname}
      board={board}
    />
  );
};

export const TrelloBoard: KnownService<OwnProps> = {
  match: {
    protocol: location.protocol,
    host: location.host,
    pathname: new RegExp(`^/b/([a-zA-Z0-9]{8})(?:$|/.*)`),
  },
  getMatchProps: ([fullUrl, pathname, shortLink]: string[]) => {
    return { fullUrl, pathname, shortLink };
  },
  Component: TrelloBoardComponent,
};
